import Vue from "vue";
import Vuex from "vuex";
import auth from "./auth.module";
import users from "./users.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import asistencias from "./asistencia";
import network from "./network";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    htmlClass,
    config,
    users,
    breadcrumbs,
    asistencias,
    network
  }
});
